import { decorate, observable } from 'mobx';
import ListData from '../toolkit/mobx-connectors/observables/list-data';

class FormulariosStore {
  list = new ListData();
}

decorate(FormulariosStore, {
  list: observable
});

const formulariosStore = new FormulariosStore();
export default formulariosStore;
